import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { AppService } from 'src/app/app.service';


@Component({
  selector: 'app-view-advisory-description',
  templateUrl: './view-advisory-description.component.html',
  styleUrls: ['./view-advisory-description.component.scss']
})
export class ViewAdvisoryDescriptionComponent implements OnInit {
  @Output() closeActivityAtDialog: EventEmitter<any> = new EventEmitter();

  windowRef: any;
  advisoryDetails: any;
  isLoading: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<ViewAdvisoryDescriptionComponent>,
    public as: AppService,
    public appService: AppService,
    public routes: ActivatedRoute,

    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.advisoryDetails = this.data['advisory'];
    this.windowRef = this.as.windowRef;
    dialogRef.disableClose = true;
  }

  ngOnInit(): void {}

  close() {
    this.dialogRef.close();
    this.closeActivityAtDialog.emit(null);
  }
}
